// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

export const BopisWrapper = styled.div`
  padding-left: 20px;
  display: flex;

  .promo-wrapper {
    display: flex;
    padding-right: 10px;
    align-items: center;
    background-color: ${(props) => props.theme.colorPalette.yellow[500]};
    min-height: 20px;
  }

  .richtextCss {
    margin-top: -2px;
    margin-left: 3px;
  }

  .triangle-left {
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 20px solid ${(props) => props.theme.colorPalette.yellow[500]};
    border-bottom: 10px solid transparent;
  }

  .triangle-top {
    margin-left: 5px;
    position: absolute;
    top: 29px;
    left: 82px;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid ${(props) => props.theme.colorPalette.yellow[500]};

    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 0;
      height: 0;
      position: inherit;
      border-top: 10px solid transparent;
      border-right: 20px solid ${(props) => props.theme.colorPalette.yellow[500]};
      border-bottom: 10px solid transparent;
      margin-left: 0;
      border-left: 0;
    }
  }

  .triangle-top + .promo-wrapper {
    width: 100%;
    max-width: 150px;
    min-height: 20px;

    .richtextCss {
      margin-right: auto;
      margin-left: auto;

      @media ${(props) => props.theme.mediaQuery.medium} {
        margin-left: 3px;
      }
    }
  }
`;

const styles = css``;

export default styles;
